import ReactDOM from 'react-dom';

const fn = function (attribute) {
  return {
    select: function (start, end) {
      end = end || start;
      let inputItem = this[attribute].current;

      let input = ReactDOM.findDOMNode(inputItem);

      if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(start, end);
      } else if (input.createTextRange) {
        range = input.createTextRange;
        range.collapse(true);
        range.moveEnd('character', end);
        range.moveStart('character', start);
        range.select();
      }
    }
  };
};

export default fn;
